import { type AxiosInstance } from "axios";
import * as Sentry from "@sentry/react";
import {
  type PostDataTransferRequest,
  type PostDataTransferResponse,
} from "@/features/salesforceIntegration/types";
import { postDataTransferResponseSchema } from "@/features/salesforceIntegration/schemas/transferEligibility";

export const DATA_TRANSFERS_ENDPOINT = "/salesforce/data-transfers/";

/**
 * 登記取得リクエストのSalesforce連携を受け付ける（`POST /salesforce/data-transfers/`）。
 * `202`で`transferId`を返す非同期処理のため、以降は`getDataTransfer`でポーリングする。
 *
 * `transferId`はポーリングキーになるため、`getDataTransfer`と同様に実行時に契約を検証する。
 */
export const postDataTransfer = async (
  apiClient: AxiosInstance,
  body: PostDataTransferRequest
): Promise<PostDataTransferResponse> => {
  const { data } = await apiClient.post<unknown>(DATA_TRANSFERS_ENDPOINT, body);

  const parsed = postDataTransferResponseSchema.safeParse(data);
  if (!parsed.success) {
    const error = new Error(
      `API contract violation at ${DATA_TRANSFERS_ENDPOINT}`
    );
    Sentry.captureException(error, { extra: { issues: parsed.error.issues } });
    throw error;
  }

  return parsed.data;
};
